/*
 * -empire: transition speed for sections/slideshow-empire.liquid
 *
 * Stock assets/slideshow-component.js builds its Swiper options internally and
 * never passes `speed`, so Swiper runs at its 300ms default. Rather than fork
 * that file (assets/theme-editor.js looks slides up via
 * closest('slideshow-component'), so a renamed element would break slide
 * selection in the editor), this reads data-speed from the element and sets it
 * on the live Swiper instance after the stock component has initialised.
 *
 * Swiper reads params.speed when each transition starts (autoplay, dots,
 * swipe, keyboard), so setting it after init applies to every later change.
 *
 * Depends on the stock component exposing `sliderInstance.slider`, the same
 * property theme-editor.js relies on. If a theme update renames it, this
 * becomes a no-op and the slider falls back to 300ms. It does not throw.
 */
(() => {
  if (window.__empireSlideshowSpeed) return;
  window.__empireSlideshowSpeed = true;

  const applySpeed = (root) => {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    root.querySelectorAll('slideshow-component[data-speed]').forEach((element) => {
      const slider = element.sliderInstance && element.sliderInstance.slider;
      const speed = parseInt(element.dataset.speed, 10);

      if (!slider || !slider.params || !Number.isFinite(speed) || speed < 0) return;

      slider.params.speed = speed;
    });
  };

  // Custom element upgrades run synchronously inside customElements.define(),
  // so by the time this resolves every slideshow on the page has initialised.
  customElements.whenDefined('slideshow-component').then(() => applySpeed(document));

  // The theme editor re-renders a section when its settings change. The stock
  // component re-initialises a fresh Swiper on insertion, so re-apply.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => applySpeed(event.target));
  }
})();